import React from 'react';
import Icon from '../../../components/AppIcon';

const ApplicationSummaryCard = ({ application }) => {
  const formatDate = (dateStr) => {
    if (!dateStr) return '—';
    try {
      return new Date(dateStr)?.toLocaleDateString('en-US', {
        month: 'long', day: 'numeric', year: 'numeric'
      });
    } catch { return '—'; }
  };

  const refId = application?.id?.slice(0, 8)?.toUpperCase() || '—';

  const docTypeLabel = {
    passport: 'Passport',
    national_id: 'National ID',
    drivers_license: "Driver\'s License",
  }?.[application?.document_type] || application?.document_type || '—';

  const scoreColor = (score) => {
    if (score >= 750) return '#14B8A6';
    if (score >= 500) return '#f59e0b';
    return '#ef4444';
  };

  const fields = [
    { icon: 'User', label: 'Applicant', value: application?.full_name || '—' },
    { icon: 'Hash', label: 'Reference ID', value: refId, mono: true },
    { icon: 'Calendar', label: 'Submitted', value: formatDate(application?.created_at) },
    { icon: 'FileText', label: 'Document Type', value: docTypeLabel },
    { icon: 'Briefcase', label: 'Employment', value: application?.employment_status || '—' },
    { icon: 'TrendingUp', label: 'Income Range', value: application?.income_range || '—' },
  ];

  return (
    <div
      className="rounded-2xl p-6"
      style={{ background: 'rgba(255,255,255,0.03)', border: '1px solid rgba(255,255,255,0.08)' }}
    >
      <div className="flex items-center justify-between mb-5">
        <div className="flex items-center gap-2">
          <div
            className="w-7 h-7 rounded-lg flex items-center justify-center"
            style={{ background: 'linear-gradient(135deg,#0d9488,#1d4ed8)' }}
          >
            <Icon name="ClipboardList" size={13} color="#fff" />
          </div>
          <h2 className="text-sm font-semibold text-white" style={{ fontFamily: 'DM Sans, sans-serif' }}>Application Summary</h2>
        </div>

        {/* SC Score badge */}
        {application?.sc_score !== undefined && (
          <div
            className="flex items-center gap-1.5 px-3 py-1.5 rounded-full"
            style={{
              background: `rgba(${application?.sc_score >= 750 ? '20,184,166' : application?.sc_score >= 500 ? '245,158,11' : '239,68,68'},0.12)`,
              border: `1px solid rgba(${application?.sc_score >= 750 ? '20,184,166' : application?.sc_score >= 500 ? '245,158,11' : '239,68,68'},0.3)`,
            }}
          >
            <Icon name="Star" size={11} color={scoreColor(application?.sc_score)} />
            <span style={{ fontSize: '12px', fontWeight: 700, color: scoreColor(application?.sc_score), fontFamily: 'JetBrains Mono, monospace' }}>
              {application?.sc_score}
            </span>
            <span style={{ fontSize: '10px', color: 'rgba(255,255,255,0.4)' }}>SC Score</span>
          </div>
        )}
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        {fields?.map((field) => (
          <div
            key={field?.label}
            className="flex items-start gap-3 p-3 rounded-xl"
            style={{ background: 'rgba(255,255,255,0.03)', border: '1px solid rgba(255,255,255,0.05)' }}
          >
            <div
              className="w-7 h-7 rounded-lg flex items-center justify-center flex-shrink-0 mt-0.5"
              style={{ background: 'rgba(255,255,255,0.06)' }}
            >
              <Icon name={field?.icon} size={13} color="rgba(255,255,255,0.45)" />
            </div>
            <div className="min-w-0">
              <p style={{ fontSize: '10px', color: 'rgba(255,255,255,0.35)', marginBottom: '2px', textTransform: 'uppercase', letterSpacing: '0.05em' }}>
                {field?.label}
              </p>
              <p
                className="text-sm font-medium truncate"
                style={{
                  color: 'rgba(255,255,255,0.85)',
                  fontFamily: field?.mono ? 'JetBrains Mono, monospace' : 'DM Sans, sans-serif',
                }}
              >
                {field?.value}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ApplicationSummaryCard;
